import MetaTags from "./index";
import config from "@/lib/config";
import routes from "@/lib/routes";

export function tags(keyword, mode) {
  if (mode === "channel") {
    return {
      title: `${keyword}の動画配信 - 月額動画配信 | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル,スカパー！",
      description: `月額商品にある${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "channel")}`,
      },
    };
  } else if (mode === "store") {
    return {
      title: `${keyword}の動画配信 - 単品商品 | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,レンタル,スカパー！",
      description: `単品商品にある${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "store")}`,
      },
    };
  } else if (mode === "valueplan") {
    return {
      title: `${keyword}の動画配信 - ${config.valuePlan.text} | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,レンタル,スカパー！",
      description: `${config.valuePlan.text}にある${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword, "valueplan")}`,
      },
    };
  } else {
    return {
      title: `${keyword}の動画配信 | SPOOX(スプークス)`,
      keywords: "SPOOX,スプークス,動画配信,レンタル,スカパー！",
      description: `${keyword}の検索結果。SPOOX(スプークス)では、スポーツや映画やアニメ、音楽ライブなど、様々な動画を配信中！`,
      og: {
        type: "article",
        url: `${config.host.vod}${routes.search(keyword)}`,
      },
    };
  }
}

export default function SearchPageMetaTags({ keyword, mode }) {
  const props = tags(keyword, mode);

  return <MetaTags {...props} />;
}
